module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '886bajdc',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
